<template>
  <v-card class="my-6 pa-6">
    Explainer
  </v-card>
</template>

<script>
export default {
  name: 'Explainer',
}
</script>

<style lang="scss" scoped>
</style>